<div class="table-title">
  <div class="title-left">
    <h2>{{ title }}</h2>
    <app-doc-link [url]="docUrl" [openLogin]="true" [company]="domainName"></app-doc-link>
  </div>
  <div *ngIf="canCreate">
    <button type="button" [routerLink]="'./new'" id="action-add" class="btn btn-gradient-primary" rippleEffect>
      Adicionar
    </button>
  </div>
</div>